export const CONTROL_POINT_TYPE = {
  ANCHOR: 'ANCHOR',
  BEZIER: 'BEZIER'
}
